import DOMPurify from 'dompurify';

const allowedTicketUrl = /^(?:(?:https?):|mailto:)/i;

const hasAllowedProtocol = (value, tagName) => {
  try {
    const url = new URL(value);
    if (tagName === 'A') return ['http:', 'https:', 'mailto:'].includes(url.protocol);
    if (tagName === 'IMG') return ['http:', 'https:'].includes(url.protocol);
  } catch (error) {
    return false;
  }

  return false;
};

DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
  const tagName = node.tagName?.toUpperCase();
  const isLinkUrl = tagName === 'A' && data.attrName === 'href';
  const isImageUrl = tagName === 'IMG' && data.attrName === 'src';

  if ((isLinkUrl || isImageUrl) && !hasAllowedProtocol(data.attrValue, tagName)) {
    // DOMPurify hooks communicate attribute removal through this mutable flag.
    // eslint-disable-next-line no-param-reassign
    data.keepAttr = false;
  }
});

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName?.toUpperCase() === 'A' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export default function sanitizeTicketHtml(value) {
  return DOMPurify.sanitize(String(value ?? ''), {
    ALLOWED_TAGS: ['a', 'img', 'br'],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'target', 'rel'],
    ALLOWED_URI_REGEXP: allowedTicketUrl,
  });
}
